import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import { NotFoundError, UnderReviewError } from '#src/shared/error';

import type { PetitionCommentDataQuery, PetitionCommentDataQueryVariables } from './api.graphql';
import { PetitionCommentData } from './api.graphql';

export type Petition = Omit<NonNullable<PetitionCommentDataQuery['petition']>, 'comment'>;
export type Comment = NonNullable<NonNullable<PetitionCommentDataQuery['petition']>['comment']>;
export type PetitionCommentPageData = {
	petition: Petition;
	comment: Comment;
};

export async function getPetitionCommentPageData(
	{ gql: { fetch } }: UtilityContext,
	petitionSlug: string,
	commentId: string,
): Promise<PetitionCommentPageData> {
	const { data } = await fetch<PetitionCommentDataQuery, PetitionCommentDataQueryVariables>({
		query: PetitionCommentData,
		variables: {
			petitionSlugOrId: petitionSlug,
			commentId,
		},
		rejectOnError: true,
	});

	if (!data.petition?.comment) {
		throw new NotFoundError();
	}

	if (data.petition.status === 'UNDER_REVIEW' && !data.petition.viewerCanEdit) {
		throw new UnderReviewError();
	}

	const { comment, ...petition } = data.petition;

	return { petition, comment };
}
